<template>
	<app-button icon="left" class="btn btn-primary transparent small" @click="goBack" />
</template>

<script>
	export default {
		name: 'AppBackButton',
		methods: {
			goBack() {
				this.$router.back();
			},
		},
	};
</script>
